import React from "react";
import Logo from "../Logo";
import { PUMPFUN_URL } from "../../lib/memeData";

export const Hero = () => {
  return (
    <section
      className="relative px-5 md:px-10 pt-6 pb-10 md:pt-10 md:pb-16"
      data-testid="hero-section"
    >
      {/* floating stickers */}
      <span
        className="sticker hidden md:inline-block"
        style={{ top: "10%", left: "4%", transform: "rotate(-12deg)" }}
      >
        100% retarded
      </span>
      <span
        className="sticker hidden md:inline-block"
        style={{ top: "16%", right: "5%", background: "#2A9D8F", color: "white", transform: "rotate(8deg)" }}
      >
        zero utility ✓
      </span>
      <span
        className="sticker hidden lg:inline-block"
        style={{ bottom: "8%", left: "8%", background: "#E63946", color: "white", transform: "rotate(-6deg)" }}
      >
        not financial advice xoxo
      </span>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[1.3fr_1fr] gap-8 lg:gap-14 items-center">
        {/* TEXT */}
        <div className="text-left">
          <p className="font-display text-3xl md:text-4xl text-[#E8742C] mb-3" data-testid="hero-eyebrow">
            ✦ welcome to the dumbest coin on solana ✦
          </p>
          <h1
            className="font-display leading-[0.9] text-[#1A1A1A] text-6xl sm:text-7xl md:text-8xl lg:text-[8.5rem]"
            data-testid="hero-headline"
          >
            <span className="block">RETARDED COIN.</span>
            <span className="block text-[#E8742C]">RETARDED HOLDERS.</span>
            <span className="block">
              <span className="scribble-underline">RETARDED PRICE.</span>
            </span>
          </h1>
          <p className="mt-6 text-xl md:text-2xl max-w-2xl text-[#1A1A1A]/80">
            no roadmap. no team. no clue. just a propeller hat, a bag full of
            crayons, and an unshakeable belief that <b>line go up</b>.
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-4">
            <a
              href={PUMPFUN_URL}
              target="_blank"
              rel="noreferrer"
              className="crayon-btn"
              data-testid="hero-buy-btn"
            >
              ⚡ buy $RETARD
            </a>
            <a
              href="#socials"
              className="crayon-btn crayon-btn--ghost"
              data-testid="hero-join-btn"
            >
              join the retards
            </a>
          </div>
        </div>

        {/* LOGO */}
        <div className="flex items-center justify-center">
          <div className="relative wiggle">
            <Logo size={420} withSpinner />
            <span
              className="sticker"
              style={{ bottom: "-10px", right: "-10px", background: "#457B9D", color: "white", transform: "rotate(10deg)" }}
            >
              certified gigaretard
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
